module.exports = __webpack_public_path__ + "img/govpage_1.419546b6.png";